define([
	"dojo/_base/declare",
	"csi/table/New",
	"csi/xml"
], function(declare,New,xml) {
	
	return declare(New, {
		_onAction: function() {
			// summary: set PrimaryCollection to current Collection
			this.m_writer.changeNode(this.m_urlNode).changeAttribute("PrimaryCollection", xml.ATTR_REF, this.m_urlParent);
			this.inherited(arguments);
		}
	});
});